import service from '@/utils/server';

const modName = '/tms/planTrack/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//导入
export const trackImport = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'import',
    method: 'post',
    data
  });
};

//导出
export const trackExport = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

/**
 * 模版下载
 * @param data
 * @returns {*}
 */
export const template = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'downloadTemplate/'+ data.templateName,
    method: 'post'
  });
};

/**
 * 查看详情
 * @param data
 * @returns {*}
 */
export const getTrackDetail = data => {
  return service({
    url: modName + 'getTrackDetail/'+ data.planNo,
    method: 'post'
  });
};

/**
 * 保存提交
 * @param data
 * @returns {*}
 */
export const saveSubmit = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/transit/orderTrack/api/index.js